import React from "react";
import { isDevClient } from "../../../utils/apiBaseUrl";
import "./DevEmailSendWarning.css";

export const DevEmailSendWarning = ({ recipients = [] }) => {
  if (!isDevClient) return null;

  const emails = [
    ...new Set(
      (recipients || [])
        .map((email) => String(email || "").trim())
        .filter(Boolean)
    ),
  ];

  return (
    <div className="dev-email-send-warning" role="alert">
      <strong>
        Warning: An email will be sent in the development environment.
      </strong>
      <p>
        Sending is blocked unless ENABLE_DEV_EMAILS is explicitly enabled on
        the server.
      </p>
      <p>Recipients:</p>
      {emails.length ? (
        <ul>
          {emails.map((email) => (
            <li key={email}>{email}</li>
          ))}
        </ul>
      ) : (
        <p className="dev-email-send-warning__empty">
          No recipient emails are listed for this action.
        </p>
      )}
    </div>
  );
};
